export default __webpack_public_path__ + "static/partners-c09fc9130dbe94fbe70374ae444bab91.png";